import React from 'react'
import View from './view.js'
import useIsHovered from 'Simple/hooks/useIsHovered.js'

export default function Logic(props) {
  let [hovered, , hoverBind] = useIsHovered({
    isDisabled: false,
    isSelected: false,
  })

  return (
    <View
      hovered={hovered}
      onMouseEnter={hoverBind.onMouseEnter}
      onMouseLeave={hoverBind.onMouseLeave}
      {...props}
    />
  )
}
